module.exports = __webpack_public_path__ + "img/zsfwct3.277da80b.png";